export const certifications = [
  {
    id: "aws-ccp",
    title: "AWS Certified Cloud Practitioner",
    issuer: "Amazon Web Services (AWS)",
    issueDate: "Aug 2025",
    credentialUrl:
      "https://www.credly.com/earner/earned/badge/d6947b6e-59db-4572-a597-0b1bdfbdd535", // עדכן
    badgeSrc: "aws-ccp.png",
  },
];

export default certifications;
